export default __webpack_public_path__ + "static/ballwall_5-819a3b1734bc98e89f1c66144f92855d.jpeg";